module.exports = __webpack_public_path__ + "static/media/yappe-desktop.6d92be77.png";